export const GRAVITY = 1700;
export const FLAP_VELOCITY = -520;
export const MAX_FALL_SPEED = 820;

export const BIRD_SIZE = 56;
export const BIRD_X_RATIO = 0.3;
export const BIRD_HITBOX_INSET = 9;

export const PIPE_WIDTH = 62;
export const PIPE_GAP = 222;
export const PIPE_SPEED = 165;
export const PIPE_SPACING = 230;
export const PIPE_MARGIN = 24;
export const PIPE_START_GAP = 120;
export const MIN_PIPE_COUNT = 3;
export const MAX_PIPE_COUNT = 24;
export const FIRST_PIPE_LEAD = 420;

export const MAX_FRAME_SECONDS = 1 / 30;

export const BIRD_ROTATION_MIN = -18;
export const BIRD_ROTATION_MAX = 70;

export const PLAY_TOP_INSET = 96;
export const PLAY_BOTTOM_INSET = 8;
export const PIPE_OVERSHOOT = 240;

export const IDLE_HOVER_DURATION_S = 0.7;
export const IDLE_HOVER_AMPLITUDE = 10;

export const FLIGHT_DURATION_S = 0.7;
export const FLIGHT_WING_FLAP_S = 0.16;
export const SIDEBAR_LOGO_SIZE = 20;

export const HIGH_SCORE_STORAGE_KEY = 'bird-game-high-score';
